// extracted by mini-css-extract-plugin
export default {"Circles":"AttributeRowColors-module__Circles__ZvXXO","Circle":"AttributeRowColors-module__Circle__zHuMF"};